import { StyleSheet } from 'react-native';
import Markdown from 'react-native-markdown-display';

export default function MarkdownText({ children, style, color, ...props }) {
  const markdownStyles = StyleSheet.create({
    body: {
      fontSize: 16,
      lineHeight: 24,
      color: color || '#333',
      ...style?.body,
    },
    heading1: {
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 12,
      color: color || '#222',
      ...style?.heading1,
    },
    heading2: {
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 10,
      color: color || '#222',
      ...style?.heading2,
    },
    heading3: {
      fontSize: 18,
      fontWeight: 'bold',
      marginBottom: 8,
      color: color || '#222',
      ...style?.heading3,
    },
    paragraph: {
      marginBottom: 12,
      lineHeight: 22,
      color: color || '#333',
      ...style?.paragraph,
    },
    strong: {
      fontWeight: 'bold',
      color: color || '#333',
      ...style?.strong,
    },
    em: {
      fontStyle: 'italic',
      color: color || '#333',
      ...style?.em,
    },
    link: {
      color: '#3251B1', // Keep links as blue for visibility
      textDecorationLine: 'underline',
      ...style?.link,
    },
    list_item: {
      marginBottom: 6,
      color: color || '#333',
      ...style?.list_item,
    },
    bullet_list: {
      marginBottom: 12,
      ...style?.bullet_list,
    },
    ordered_list: {
      marginBottom: 12,
      ...style?.ordered_list,
    },
    code_inline: {
      backgroundColor: '#f5f5f5',
      padding: 2,
      borderRadius: 3,
      fontFamily: 'monospace',
      color: color || '#333',
      ...style?.code_inline,
    },
    code_block: {
      backgroundColor: '#f5f5f5',
      padding: 10,
      borderRadius: 6,
      marginBottom: 12,
      fontFamily: 'monospace',
      color: color || '#333',
      ...style?.code_block,
    },
    blockquote: {
      borderLeftWidth: 4,
      borderLeftColor: '#ccc',
      paddingLeft: 12,
      marginLeft: 6,
      fontStyle: 'italic',
      color: color || '#333',
      ...style?.blockquote,
    },
  });

  return (
    <Markdown style={markdownStyles} {...props}>
      {children}
    </Markdown>
  );
}